<template>
  <div class="status">
    <mf-icon fill class="status-icon" small :color="getStatusLabel(status).color"> stop_circle </mf-icon>
    <span>{{ getStatusLabel(status).text }}</span>
  </div>
</template>

<script>
import { getStatusLabel } from '@/config/helpers.js'

export default {
  name: 'StatusIcon',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  methods: {
    getStatusLabel,
  },
}
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  align-items: center;
  margin: 0 0 10px 0;
  .status-icon {
    font-size: 12px !important;
  }
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.2px;
    color: $cinza-d20;
    text-transform: uppercase;
    padding-left: 5px;
  }
}
</style>
